import React from 'react';
import PropTypes from 'prop-types';
import { MDBCol, MDBContainer, MDBRow } from 'mdbreact';
import login_background from '../../../Assets/login_background.png';

const MainLayout = props => {
    const { children } = props;
    // console.log("localStorage.getItem('session_id'): "+localStorage.getItem('session_id'))
    if(localStorage.getItem('session_id') != null && localStorage.getItem('session_id') != ""){
        window.location.href ="/new-visa"
    }
    // if(localStorage.getItem('session_id') == ""){
    //     window.location.href ="/login"
    // }

    return(
        <div className="h-100 w-100 " id={localStorage.getItem("host") === "visaero" ? "loginBackground" : ""} 
         style={{backgroundImage: localStorage.getItem("host") === "visaero" ? "" : `url(${login_background})`,
         backgroundRepeat: localStorage.getItem("host") === "visaero" ? "" : 'no-repeat',backgroundSize:localStorage.getItem("host") === "visaero" ? "" : 'cover'}}>

        <MDBContainer className='h-100'>
            <MDBRow className="d-flex align-items-center justify-content-end h-100">
                {/* <MDBCol size="12" md="4" ></MDBCol> */}
                <MDBCol size="12" md="5" className="text-center">
                    <main>
                        {children}
                    </main>
                </MDBCol>
                {/* <MDBCol size="12" md="4"></MDBCol> */}
            </MDBRow>
        </MDBContainer>
        </div>
    );
};

MainLayout.propTypes = {
    children: PropTypes.node
};

export default MainLayout;